/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Section_RoundsInputs */



/**
* | output |
* | --- |
* | "Rounds & timer" |
*
* @param {Tfield_Section_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_section_rounds = /** @type {((inputs?: Tfield_Section_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Section_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rondes et chrono")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rondas y cronómetro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Rodadas e cronômetro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Round e timer")
	return /** @type {LocalizedString} */ ("Rounds & timer")
});